<agr-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirmFertilizerImport()"
  (cancel)="cancel()"
  #ngForm="ngForm"
>
  <div class="dialog spacing--margin-top">
    @if (!fertilizersArray.controls.length) {
      <div>
        <h4>{{ 'noMineralDeliveriesFound' | translate }}</h4>
      </div>
    }
    @for (
      fertilizerForm of fertilizersArray.controls;
      track fertilizerForm;
      let index = $index;
      let first = $first
    ) {
      <div class="fertilizer-row">
        <app-fertilizer-form
          [formGroup]="getFormGroup(index, fertilizersArray)"
          [isBatchEdit]="this.isBatchEdit"
          [showDeleteButton]="data.rowIndex === null || data.rowIndex === undefined"
          (deleteFertilizer)="deleteFertilizer($event)"
          [class.spacing--margin-top]="!first"
          class="flex__child--auto"
        ></app-fertilizer-form>
        <mat-divider></mat-divider>
      </div>
    }
  </div>
  @if (showVdmImportButtons()) {
    <div class="vdm-form-action-buttons">
      <button mat-button (click)="closeVdmImport()">{{ data.cancelButtonText }}</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!getFormGroup(0, fertilizersArray).valid"
        class="vdm-save-button"
        (click)="confirmVdmImport()"
        cdkFocusInitial
      >
        {{ data.confirmButtonText }}
      </button>
    </div>
  }
</agr-dialog>
